/**
 * <EditPoster
 *		// please describe props here
 *	/>
 *
 * - When there is a nesting tr, we use tbody as a row.
 *
 * @parent anybody
 * @children
 * @stateful
 * @stateless
 */
import React, { PropTypes } from 'react';
import ReactQuill from 'react-quill';
import classnames from 'classnames'
import {browserHistory, Link} from 'react-router'
import 'react-quill/dist/quill.snow.css';
import TicketList from './Register/TicketList.js';
import { connect } from 'react-redux';
import Item from './Item.js';
import './EditPoster.scss';
import updatePoster from 'controllers/poster/updatePoster'
import confirm from 'util/confirm';
import Dropzone from 'react-dropzone';
import ImageCropper from 'template/Modals/ImageCropper';
import uploadPicture from 'controllers/poster/uploadPicture'
import Loading from 'components/UI/Loading';
import PanelWrapper from 'components/UI/PanelWrapper';
import {alert} from 'util/alert'

import {
  fetchPosterDetail,
  updateTitle,
  updateTicket,
  createTicket,
  deleteTicket,
  updateContentItem,
  addContentItem,
  removeContentItem,
  updateOrder,
} from './ducks'

import _ from 'lodash'
import locale from './locale'

const ACCEPT_MIME = 'image/png,image/jpeg';
const MAX_SIZE = 5 * 1000 * 1000;
const MIN_SIZE = 0;

const mapStateToProps = (state) => ({
  user: state.user,
  posterDetail: state.posterDetail,
});

class EditPoster extends React.Component {
  static propTypes = {

  }

  static defaultProps = {

  }

  constructor(props) {
    super(props);

    this.state = {
      itemBeingEdited: {},
      showAddOption: {},
      lastItem: false,
    };

    this.onChange = this.onChange.bind(this);
    this.addItem = this.addItem.bind(this);
    this.removeItem = this.removeItem.bind(this);
    this.openEditor = this.openEditor.bind(this);
    this.updateText = this.updateText.bind(this);
    this.onSort = this.onSort.bind(this);
    this.addTicket = this.addTicket.bind(this);
    this.removeTicket = this.removeTicket.bind(this);
    this.onTicketChange = this.onTicketChange.bind(this);
    this.onTitleChange = this.onTitleChange.bind(this);

    const { posterId } = this.props.routeParams;
    this.posterId = posterId; //

  }

  onChange(ref) {
  }

  componentWillMount() {
    this.props.fetchPosterDetail(this.posterId, () => {
      let lastItem = this.props.posterDetail.contentList.length == 1
      this.setState({
        itemBeingEdited: this.props.posterDetail.contentList[0],
        showAddOption: {[this.props.posterDetail.contentList[0].id]: true},
        lastItem: lastItem,
      })
    });
  }

  openEditor(itemBeingEditedIndex, itemBeingEdited) {
    return ()=>{
      this.setState({
        itemBeingEditedIndex,
        itemBeingEdited,
        showAddOption: {
          [itemBeingEdited.id]: true
        }
      });
    }
  }

  addItem(index) {
    return (type, contentIn)=>{
      if (type == 'picture') {
        this.props.addContentItem(index, this.posterId, { content_type: "picture", ...contentIn });
      }
      if (type == 'text') {
        this.props.addContentItem(index, this.posterId, { content_type: "text", ...contentIn });
      }
    }
  }

  removeItem(index, contentId) {
    return ()=>{
      confirm(__('Proceed to delete item?', locale), __('Delete Item', locale))
      .then(()=>{
        this.setState({itemBeingEdited: {}})
        this.props.removeContentItem(index, contentId, this.posterId);
      })
      .catch(()=>{});
    }
  }

  //
  // ticket: START
  //
  addTicket(type) {
    const {ticketList = []} = this.props.posterDetail

    this.props.createTicket(this.posterId, {title: '', index: ticketList.length + 1, price_type: type})
  }

  removeTicket(index, ticket) {

    return () => {
      const { endDate, endTime, title, price } = ticket;
      const priceFloat = typeof price === 'undefined' ? price : parseFloat(price);

      if (endDate || endTime || title || priceFloat) {
        confirm(__('Proceed to delete this registration?', 'ticket')).then(() => {
          this.props.deleteTicket(ticket.id, index)
        })
      } else {
        this.props.deleteTicket(ticket.id, index)
      }

    }

  }

  onTicketChange(index, ticketId){
    return (newSettings) => {
      clearTimeout(this.updateTextTimeout);

      this.updateTextTimeout = setTimeout(()=>{
        this.props.updateTicket(ticketId, newSettings)
      }, 500);

    }
  }
  //
  // ticket: END
  //

  updateText(text) {
    if (!text) {
      return;
    }

    const { itemBeingEdited, itemBeingEditedIndex } = this.state;

    const { content_type } = itemBeingEdited;

    clearTimeout(this.updateTextTimeout);

    this.setState({
      itemBeingEdited: {
        ...itemBeingEdited,
        text,
      },
      updating: true,
    });

    this.updateTextTimeout = setTimeout(()=>{
      this.props.updateContentItem(itemBeingEditedIndex, itemBeingEdited.id, {
        content_type,
        text,
      });

      this.setState({
        updating: false,
      });
    }, 250);
  }

  onTitleChange(event){
    const title = event.target.value;

    clearTimeout(this.updateTextTimeout);
    this.props.updateTitle(title);

    this.updateTextTimeout = setTimeout(()=>{
      updatePoster(this.posterId, {title})
      .then((res) => {console.log(res)})
    }, 500);
  }

  onSort(newOrder) {
    this.newOrder = newOrder;
  }

  onDragEnd(item) {
    return ()=>{
      this.props.updateOrder(this.newOrder, item);
    }
  }

  selectImage(accepted, rejected){

    if (rejected.length > 0) {
      alert.warning(__('Image file must be png/jpeg under 5 MB', 'image'), __('Image not qualified', 'image'));
      return;
    } else if (accepted.length === 0) {
      alert.warning('', __('No Image Selected'));
      return;
    }

    ImageCropper({
      file: accepted[0]
    })
    .then(({ file, imageUrl, dataUrl })=>{
      let {addItem, posterId} = this.props

      if (file) {
        this.setState({
          creating: true,
        });

        uploadPicture(posterId, file)
          .then((res) => {
            addItem('picture', {
              image_url: res.save_to,
            });

            // STEP 3. CREATING COMPLETE
            this.setState({
              creating: false,
            });
          });
      }

    })
    .catch((err)=>{

    });
  }

  render() {
    const {
      contentList = [],
      ticketList = [],
      title,
      fetching,
      poster_type,
    } = this.props.posterDetail;
    const {itemBeingEdited = [], showAddOption} = this.state;
    const hasOneItem = contentList.length === 1;

    let hasTitle = true;
    let hasPrice = true;
    if(ticketList){
      ticketList.map((ticket) => {
        if(!ticket.title){
          hasTitle = false
        }
        if(ticket.price_type == 'fixedAmount' && Number(ticket.price) <= 0 ){
          hasPrice = false
        }
      })
    }

    return (
      <PanelWrapper>
        <div className='bread-crumbs'>
          <Link to='/poster'>{__('Poster', locale)}</Link>
          <span> / </span>
          <span>{__('Edit Poster', locale)}</span>
          <Link className='pull-right' to={'/poster'}>
            <i className='fa icon-cancel'></i>
		      </Link>
        </div>
        <div className='EditPoster'>
          <h3>{__('Poster Title', locale)}</h3>
          <button className='pull-right btn btn-primary' onClick={() => {
            if(!title){
              return alert.warning(__('Please enter poster title', locale))
            }
            if(poster_type == 'registration' && ticketList.length <= 0){
              return alert.warning(__('Please enter registration setup', locale))
            }
            if(ticketList && !hasTitle){
              return alert.warning(__('Please enter registration title', locale))
            }
            if(ticketList && (!hasTitle || !hasPrice)){
              return alert.warning(__('Please enter registration price', locale))
            }
            updatePoster(this.posterId, {title, state: 'published'})
            .then(() => {browserHistory.push('/poster')})
          }}>{__('Publish', locale)}</button>
          <button className='pull-right btn btn-orange' onClick={() => {
            if(!title){
              return alert.warning(__('Please enter poster title', locale))
            }
            if(poster_type == 'registration' && ticketList.length <= 0){
              return alert.warning(__('Please enter registration setup', locale))
            }
            if(ticketList && !hasTitle){
              return alert.warning(__('Please enter registration title', locale))
            }
            if(ticketList && (!hasTitle || !hasPrice)){
              return alert.warning(__('Please enter registration price', locale))
            }
            updatePoster(this.posterId, {title, state: 'draft'})
            .then((res) => {
              // if(res.result == 'failure' && res.reason == 'The poster ticket(s) have(s) been ordered.'){
              //   alert.warning(__('This poster has people registered, you can not edit poster', locale))
              // } else {
              // }
              browserHistory.push('/poster')
            })
          }}>{__('Save', locale)}</button>
          <a href={'/poster-preview/' + this.posterId} target='_blank' className='pull-right btn btn-default'>{__('Preview', locale)}</a>
          <div className='edit-poster-header'>
          <section className='TitleControlSection'>
            <input className='form-control' value={title} onChange={this.onTitleChange} placeholder={__('Enter poster title', locale)} maxLength="200" />
            <div className='text-count pull-right'>{(title || '').length} / 200</div>
          </section>
          </div>

          <h3>{__('Poster Content', locale)}</h3>
          <section className='ContentSection'>
            <div className={classnames('ContentList', { hasOneItem })}>
              <ul className='sortable-list'>
                {contentList.map((item, index)=>{
                  return <Item
                    key={index}
                    item={item}
                    onClick={this.openEditor(index, item)}
                    addItem={this.addItem(index)}
                    removeItem={this.removeItem(index, item.id)}
                    posterId={this.posterId}
                    showAddOption={showAddOption}
                    // react-sortable props:h
                    sortId={index}
                    items={contentList}
                    onSortItems={this.onSort}
                    onDragEnd={this.onDragEnd(item)}
                  />
                })}
              </ul>
            </div>
            <div className='ContentEditor'>
              { itemBeingEdited.content_type == 'picture' && <img src={itemBeingEdited.image_url}/> }
              { itemBeingEdited.content_type == 'text' &&  <ReactQuill value={itemBeingEdited.text || ''} onChange={this.updateText} /> }
            </div>
          </section>
          {poster_type !== 'basic' && <hr />}
          {poster_type !== 'basic' && <section className='RegisterSection'>
            <TicketList
              ticketList={ticketList}
              onTicketChange={this.onTicketChange}
              addTicket={this.addTicket}
              removeTicket={this.removeTicket}
            />
          </section>}
        </div>
      </PanelWrapper>
    )
  }
}

export default connect(mapStateToProps, {
  updateOrder,

  fetchPosterDetail,

  updateTitle,
  updateTicket,
  createTicket,
  deleteTicket,

  updateContentItem,
  removeContentItem,
  addContentItem,
})(EditPoster)



// WEBPACK FOOTER //
// ./src/containers/pages/Poster/EditPoster/index.js